import ForgotpasswordForm from './model/form.model';

class ForgotpasswordController {
  constructor(StorageService, $window) {
    'ngInject';

    this.StorageService = StorageService;
    this.$window = $window;
  }

  $onInit() {
    this.form = new ForgotpasswordForm();
    this.getOrigin = this.getOrigin.bind(this);
    this.$window.addEventListener('message', this.getOrigin);
  }

  getOrigin(e) {
    let parseData = JSON.parse(e.data);
    origin = parseData.origin_from;
    this.$window.localStorage.setItem(origin, parseData.origin_from);
  }
}

export default ForgotpasswordController;



// WEBPACK FOOTER //
// ./client/app/pages/forgotpassword/forgotpassword.controller.js